module.exports = __webpack_public_path__ + "static/media/icon-business.1046c02f.svg";